import classnames from 'classnames';
import * as React from 'react';
import styles from './styles.scss';

interface Props {
  label: string;
  children?: React.ReactNode;
  className?: string;
}

const FormItem = ({ label, children, className }: Props): JSX.Element => {
  return (
    <div className={classnames(styles.container, className && className)}>
      <h3 className={styles.header}>{label}</h3>
      {children}
    </div>
  );
};

export default FormItem;
